var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-57 -145)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a-dashboard",
    transform: "translate(57 145)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c-dashboard",
    width: 21,
    height: 21,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d-dashboard",
    x: 0.9,
    y: 0.9,
    width: 19.2,
    height: 19.2,
    rx: 2.1
  })), /*#__PURE__*/React.createElement("line", {
    className: "b-dashboard",
    x2: 10,
    transform: "translate(57.5 152.5)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b-dashboard",
    x2: 10,
    transform: "translate(67 158.5)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b-dashboard",
    y2: 18.5,
    transform: "translate(67.5 146)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.da2253a6c89a1d7bc4cfe11ea3545d86.svg";
export { ForwardRef as ReactComponent };